import { Box, Button } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'

interface ActionsProps {
  invoiceId: string
}

const Actions = ({ invoiceId }: ActionsProps) => {
  const { navigation } = useNavigation()
  return (
    <Box justifyContent="center" alignItems="center">
      <Button.Router
        type="secondary"
        to={navigation.finance.invoices.list.invoiceId.fullPath({ invoiceId })}
        iconName="arrow-right"
      />
    </Box>
  )
}

export default Actions
